
export default class MediaPlayback {
    /**
     * Class constructor
    */
    
    constructor(item) {
        if(!item) {
            return;
        }
        this.init(item);
    }

    init(item) {
        this.addEventListeners(item);
    }

    addEventListeners(item) {
        item.addEventListener('click', () => {
            if (!item.classList.contains('is-paused')) {
                item.classList.add('is-paused');
                item.nextElementSibling.pause();
                this.togglePlayPauseIcon(item);
            } else {
                item.classList.remove('is-paused');
                item.nextElementSibling.play();
                this.togglePlayPauseIcon(item);
            }
        })
    }

    togglePlayPauseIcon (item) {
        const icons = item.querySelectorAll('div');
        icons.forEach(icon => {
            if (icon.classList.contains('hidden')) {
                icon.classList.remove('hidden');
            } else {
                icon.classList.add('hidden');
            }
        })
    }
}
